document.addEventListener("DOMContentLoaded", function () {
  let clicked = false; // don't allow someone to submit multiple forms by spam clicking
  jQuery(function ($) {
    $(".subscribe__form").on("submit", function (event) {
      event.preventDefault();

      $("#email__field-error").css("display", "none");
      $(".subscribeSubmit").addClass("loading");

      if (clicked === true) {
        return;
      }
      clicked = true;

      let email = document.querySelector(".email__field").value;
      let firstName = document.querySelector(".name__field").value;
      let postcode = document.querySelector(".postcode__field").value;

      if (isEmail(email)) {
        $(".subscribeSubmit").removeClass("loading");
        callSubscribe(email, firstName, postcode);
      } else {
        $("#email__field-error").css("display", "initial");
        $(".subscribeSubmit").removeClass("loading");
        clicked = false;
      }
      return false;
    });
  });

  function callSubscribe(email, firstName, postcode) {
    var data = {
      action: "subscribe_newsletter_backend", //php function name
      email: email,
      name: firstName,
      postcode: postcode,
    };

    let formContainer = document.querySelector(".subscribe__wrapper__width");
    formContainer.classList.toggle("form__animation__submit"); // play animation when loading (changes opacity slightly)

    jQuery.ajax({
      type: "post",
      dataType: "json",
      url: "/wp-admin/admin-ajax.php",
      data: data,
      success: function (response) {
        formContainer.classList.toggle("form__animation__submit"); // revert loading amimation
        response = JSON.parse(response);
        if (response.success === true) {
          thankMessage(); // display success message
          pushAnalyticsEvent();
        } else {
          console.error("Error with request", response);
          clicked = false;
        }
      },
    });
  }

  function thankMessage() {
    // remove the form
    let form = document.querySelector(".subscribe__form");
    form.remove();

    // toggle the success message that is hidden in the dom;
    let displaySuccess = document.querySelector(".success__message");
    displaySuccess.classList.toggle("invisible");
  }

  function pushAnalyticsEvent() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "on-newsletter-form-submission" });
  }
});

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}
